import React from 'react';
import { useWindowSize } from 'src/hooks/useWindowSize';
import { MEDIUM_BREAKPOINT } from '../modular-grid/constants';
import config from '../../config';

import SearchInputComponent from '../SearchInput';
import styles from './SearchBar.module.scss';

interface SearchInputPropsTypes {
  state?: 'active' | 'inactive';
  placeholder_new: {
    default: string;
    active: string;
  };
  clearText: string;
  search_modal_link: string;
  onSearchWrapperClick?: (args: { path: string }) => void;
}

const SearchInput: React.FC<SearchInputPropsTypes> = ({
  state = 'active',
  placeholder_new,
  search_modal_link,
  onSearchWrapperClick,
  clearText,
}) => {
  const mode = config.staticComponents['Search']?.mode || 'default';
  const width = useWindowSize().width;

  const onSearchClick = ({ path }: { path: string }) =>
    onSearchWrapperClick!({ path });

  const SearchInputCmpSmall = (
    <div className={styles.wrapper}>
      <SearchInputComponent
        state={state}
        searchLink={search_modal_link}
        placeholderText_New={placeholder_new}
        onSearchWrapperClick={onSearchClick}
        clearText={clearText}
      />
    </div>
  );
  const SearchInputCmpLarge = null;

  const SearchInputCmpResponsive =
    width > MEDIUM_BREAKPOINT.max ? SearchInputCmpLarge : SearchInputCmpSmall;

  return mode === 'default'
    ? SearchInputCmpResponsive
    : mode === 'small'
    ? SearchInputCmpSmall
    : SearchInputCmpLarge;
};

export default SearchInput;
